import { render, staticRenderFns } from "./returnschedule.vue?vue&type=template&id=5a660ae4&"
import script from "./returnschedule.vue?vue&type=script&lang=js&"
export * from "./returnschedule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports